import { COLOR_PALETTE } from 'constants/ui';

export const tabBarContainerStyles = {
  display: 'flex',
  justifyContent: 'space-around',
  alignItems: 'center',
  borderTop: ({ palette }) => `1px solid ${palette.border.default}`,
  padding: '0',
  flexShrink: 0,
  backgroundColor: ({ palette }) => `${palette.background.paper} !important`,
};

export const tabButtonStyles = ({ palette }) => ({
  '&&': {
    minWidth: 'auto',
    flex: 1,
    flexDirection: 'column',
    padding: '32px 4px',
    gap: '2px',
    borderRadius: 0,
    textTransform: 'none',
    backgroundColor: 'transparent',
    color: palette.text.secondary,
    boxShadow: 'none',

    '&[data-is-active="true"]': {
      color: COLOR_PALETTE.BRAND[6],
      backgroundColor: 'transparent',
    },

    '&:hover': {
      backgroundColor: palette.background.disabled,
      boxShadow: 'none',
    },
  },
});

export const activeIndicatorStyles = {
  position: 'absolute',
  bottom: 0,
  left: '25%',
  right: '25%',
  height: '2px',
  backgroundColor: COLOR_PALETTE.BRAND[6],
  borderRadius: '1px',
};

export const tabLabelStyles = {
  fontSize: '10px',
  lineHeight: 1.2,
};
